<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Public Access",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Public Access",
      items: [
        {
          text: "Home",
        },
         {
          text: "Settings",
        },
        {
          text: "Public Access",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>